export default __webpack_public_path__ + "static/media/step_2.7be15575.png";